import { singleton } from "tsyringe";
import { BackgroundComponent } from "~/src/components/background";
import { PaintingsSliderComponent } from "../components/paintings-slider";
import { EventBus } from "../event-bus";
import { AppState } from "../app-state";
import { PaintingPreludeComponent } from "../components/painting-prelude";
import { AssetsLoader } from "../assets-loader";
import { PaintingNavComponent } from "../components/painting-nav";
import { POINT_LIGHT_BRIGHTNESS } from "../config/lights";
import { IS_TOUCH } from "../config/env";

@singleton()
export class ScreensOrchestrator {
  constructor(
    private background: BackgroundComponent,
    private paintingsSlider: PaintingsSliderComponent,
    private eventBus: EventBus,
    private appState: AppState,
    private paintingPrelude: PaintingPreludeComponent,
    private assetsLoader: AssetsLoader,
    private paintingNav: PaintingNavComponent
  ) {}
  async fromHomeToPainting() {
    const { key } = this.appState.activePaintingData;
    const { background, paintingsSlider: slider, paintingNav: nav } = this;
    const loadingPromise = this.assetsLoader.loadPainting(key);
    await Promise.all([background.fadeOut(), slider.exit()]);
    await Promise.all([this.paintingPrelude.enter(), loadingPromise]);
    await this.paintingPrelude.exit();
    background.changeBackground(key, key + "normal");
    background.setPointLightBrightness(1);
    if (IS_TOUCH) {
      background.enableAmbientLight();
    }
    this.background.enableInteraction();
    await nav.enter();
  }
  async fromPaintingToHome() {
    const { background, paintingsSlider: slider, paintingNav: nav } = this;
    nav.disableInteraction();
    background.disableInteraction();
    background.setPointLightBrightness(POINT_LIGHT_BRIGHTNESS);
    background.disableAmbientLight();
    await Promise.all([nav.exit()]);
    await slider.enter();
  }
  async fromHomeToSamePainting() {
    await this.paintingsSlider.exit();
    this.background.setPointLightBrightness(1);
    if (IS_TOUCH) {
      this.background.enableAmbientLight();
    }
    await this.paintingNav.enter();
    this.background.enableInteraction();
  }
  async fromPaintingToPainting() {
    const { key } = this.appState.activePaintingData;
    const { background, paintingNav: nav } = this;
    const loadingPromise = this.assetsLoader.loadPainting(key);
    background.disableInteraction();
    await Promise.all([background.fadeOut(), nav.exit()]);
    await Promise.all([this.paintingPrelude.enter(), loadingPromise]);
    await this.paintingPrelude.exit();
    background.changeBackground(key, key + "normal");
    background.setPointLightBrightness(1);
    if (IS_TOUCH) {
      background.enableAmbientLight();
    }
    background.enableInteraction();
    await nav.enter();
  }
}
